import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  OrderCustomerIdentificationEnumResponseDto,
  OrderCustomerTypeEnumResponseDto,
} from '@core/services/apiclient';
import { ExtendedOrderCustomer } from '../models/extended-orderCustomer.model';

@Injectable({
  providedIn: 'root',
})
export class OrderCustomerUtilsService {
  private readonly translate = inject(TranslateService);

  public getAnonymousCustomer(displayAnonymousName: boolean): ExtendedOrderCustomer {
    return {
      address: null,
      customerType: OrderCustomerTypeEnumResponseDto.Physical,
      email: '',
      id: -1,
      phoneNumber: '',
      firstName: displayAnonymousName ? this.translate.instant('shared.customer.customer') : '',
      lastName: displayAnonymousName ? this.translate.instant('shared.customer.anonymousCustomerShort') : '',
      displayableName: displayAnonymousName
        ? this.translate.instant('shared.customer.anonymousCustomer')
        : '',
      isAnonymous: true,
      archived: false,
      identificationType: OrderCustomerIdentificationEnumResponseDto.Anonymous,
    };
  }
  public setCustomerName(customer: ExtendedOrderCustomer): ExtendedOrderCustomer {
    if (customer?.isAnonymous) {
      customer.firstName = this.translate.instant('shared.customer.customer');
      customer.lastName = this.translate.instant('shared.customer.anonymousCustomerShort');
      customer.displayableName = this.translate.instant('shared.customer.anonymousCustomer');
    }
    return customer;
  }
}
